import { useFeatureFlags } from '@/features/feature-flags';
import React from 'react';
import { View } from 'react-native';
import { SECTION_ORDER } from '../registry';
import { SettingsRegistrySection } from './settings-registry-section';

/**
 * Renders the entire settings catalog from the registry, section by section, in
 * declared order. Reads the feature-flag map once through the flag seam and
 * hands it to each section, which hides any entry whose flag is off. Each row
 * self-fetches through its hook, so this view is purely structural — the single
 * source of truth for what settings exist and where.
 */
export function SettingsRegistryView() {
  const flags = useFeatureFlags();
  return (
    <View>
      {SECTION_ORDER.map((section) => (
        <SettingsRegistrySection key={section} section={section} flags={flags} />
      ))}
    </View>
  );
}
